<template>

	<div id="app">
		<transition :name="transitionName">
			<navigation>
				<router-view class="Router"></router-view>
			</navigation>
		</transition>
	</div>

</template>

<style lang="less">
	
	/* 矢量图标库 */
		@import './common/icon.css';
		
		/* 动画库 */
		@import './common/animate.css';
		
		/* 公共css */
		@import './common/common.less';
	
	@font-face {
	  font-family: 'MyHeiti';
	  src: url('https://aee-course.oss-cn-shenzhen.aliyuncs.com/index/simhei.ttf');
	  font-weight: normal;
	  font-style: normal;
	}
	
	body {
		font-size: 16px;
		/* background-color: #f8f8f8; */
		-webkit-font-smoothing: antialiased;
	}
	.Router {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
	}
	
	.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 500ms;
  position: absolute;
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
	/*布局*/
	.weui-flex{display: flex;}
	.weui-flex .weui-flex__item{width: 100%;}

	/*遮罩层*/
	.Loading{text-align: center;padding-top: 50%;background-color: rgba(255,255,255,0.8);position: fixed;height: 100%;width: 100%;z-index: 999;}
	
	/*自定义背景*/
	.colorbg{background-color: #EE0A24 !important;border: #EE0A24 !important;}
	
</style>

<script>
	export default {　
		data(){
			return {
				transitionName:'',
			}
		},　
		
		created() {
	      // bind event
	      this.$navigation.on('forward', (to, from) => {
	      	console.log('前进')
	      	this.transitionName = 'slide-left';
	      })
	      this.$navigation.on('back', (to, from) => {
	      	console.log('后退')
	      	this.transitionName = 'slide-right';
	      })
	      this.$navigation.on('replace', (to, from) => {
	      	this.transitionName = '';
	      })
	    }
	}
</script>